export const RelatedPeopleBDC = ({data}) => {
  return (
    <>
      {/* <h3 className="pt-10">{estrutura.titulo}</h3> */}

      <table className='table fs-7 gs-0 table-condensed table-sm'>
        <thead>
          <tr>
            <th className='fs-bold px-0'>Nome</th>
            <th className='fs-bold px-0'>CPF</th>
          </tr>
        </thead>
        <tbody>
          {/* 
        {dateReturn?.map((item, index) => {
          return (
            <tr key={index}>{estrutura['colunsItens'].map((column, index2) => {
                return <td key={index2}>{item[column]}</td>
              })}
            </tr>
          )
        })} */}

          {data?.map((item, index) => {
            return (
              // eslint-disable-next-line array-callback-return
              <tr key={index}>
                <td>{item.Name}</td>

                <td>{item.DocumentFormatted}</td>
                {/* {
                  // eslint-disable-next-line array-callback-return
                  estrutura['colunsItens'].map((column, index2) => {
                    if (item.RelationshipType !== 'COLLEGECLASS') {
                      return (
                        <td key={index2} className='px-0'>
                          {item[column]}
                        </td>
                      )
                    }
                  })
                } */}
              </tr>
            )
          })}
        </tbody>
      </table>
    </>
  )
}
